import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { App as AntdApp } from 'antd'
import AntdAppInitializer from './components/AntdAppInitializer'
import 'antd/dist/reset.css';
import "./index.css"
import { installGlobalAxiosInterceptor } from './globalAxiosInterceptor'

// Installed FIRST, before React renders anything — guarantees this runs
// ahead of any component's own axios calls, regardless of import order
// or bundling quirks elsewhere in the app.
installGlobalAxiosInterceptor()

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <AntdApp>
      <AntdAppInitializer />
      <App />
    </AntdApp>
  </Provider>,
)

reportWebVitals()